<form class="coverPathForm" id="licenseForm" [formGroup]="licenseForm">
  <div class="correction-form__container">
    <div class="form form--license">
      <div class="correction-form__question">
        <div class="correction-form__content correction-header">{{ headerText }}</div>
        <div class="correction-form__label form__label">
          <basic-label displayText="License Number"></basic-label>
        </div>
        <div class="form__field">
          <basic-text-input
            #idNumberValue
            formControlName="licenseNumber"
            [formGroupComponent]="true"
            (focusin)="showLicenseNumber()"
            (focusout)="obfuscateLicenseNumber()"
            [ngClass]="{
              'entry-field--error': licenseForm.get('licenseNumber').errors && licenseForm.get('licenseNumber').touched
            }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="licenseForm.get('licenseNumber')"
          ></control-messages>
        </div>
      </div>

      <div class="correction-form__question">
        <div class="correction-form__label form__label">
          <basic-label displayText="State"></basic-label>
        </div>
        <div class="form__field">
          <select-basic
            [propertyName]="'customer.application.primaryPolicy.' + personString + '.idState'"
            formControlName="licenseState"
            [ngClass]="{
              'entry-field--error': licenseForm.get('licenseState').errors && licenseForm.get('licenseState').touched
            }"
          ></select-basic>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="licenseForm.get('licenseState')"
          ></control-messages>
        </div>
      </div>

      <div class="correction-form__question">
        <div class="correction-form__label form__label">
          <basic-label displayText="Expiration Date"></basic-label>
        </div>
        <div class="form__field">
          <basic-text-input
            formControlName="licenseExpiration"
            [formGroupComponent]="true"
            [parserType]="'Date'"
            [formatterType]="'date_mmddyyyy'"
            [ngClass]="{
              'entry-field--error':
                licenseForm.get('licenseExpiration').errors && licenseForm.get('licenseExpiration').touched
            }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="licenseForm.get('licenseExpiration')"
          ></control-messages>
        </div>
      </div>
    </div>
  </div>
</form>
<button
  *ngIf="changesWereMade"
  class="correction-form__button button button--primary button--yellow"
  [ngClass]="{ 'button--disabled': this.licenseForm.valid === false }"
  (click)="validateAndContinue()"
>
  Update
</button>
<button
  *ngIf="!changesWereMade"
  class="correction-form__button button button--primary button--yellow"
  [ngClass]="{ 'button--disabled': this.licenseForm.valid === false }"
  (click)="goToOR1()"
>
  Everything Looks Right
</button>
